module.exports = __webpack_public_path__ + "static/img/Bachelor_010349.77731de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010349.jpg
// module id = 153
// module chunks = 0